{
  "app": {
    "name": "UWU Support"
  },
  "nav": {
    "skip": "Skip to main content",
    "inbox_mine": "My Inbox",
    "team": "Team",
    "team_unassigned": "Unassigned",
    "team_all": "Whole team",
    "all": "All",
    "new_ticket": "New ticket",
    "profile": "Profile",
    "logout": "Sign out",
    "palette": "Command palette (⌘K)",
    "user_menu": "User menu",
    "open_sidebar": "Open menu",
    "group_mine": "Mine",
    "view_mine": "Assigned to me",
    "view_mentioned": "Mentioned",
    "view_snoozed": "Snoozed",
    "view_closed": "Closed",
    "team_group": "Team {{code}}",
    "team_all_hold": "Whole team",
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar",
    "kb": "Knowledge base",
    "realtime_on": "Realtime connected",
    "realtime_off": "Offline — polling periodically",
    "knowledge": "Knowledge"
  },
  "login": {
    "title": "Sign in",
    "subtitle": "Company-wide support system — use your UWU ID account",
    "pending": "Signing in…",
    "button": "Sign in with UWU ID"
  },
  "loggedOut": {
    "title": "Signed out",
    "body": "You have been signed out",
    "again": "Sign in again",
    "unverified": "We couldn't verify this logout link. If you just logged out, you're all set."
  },
  "inbox": {
    "title_mine": "My Inbox",
    "title_team_unassigned": "{{team}} · Unassigned",
    "title_team_all": "{{team}} · Whole team",
    "title_watching": "Watching",
    "title_all": "All tickets",
    "empty": "No tickets in this view",
    "load_more": "Load more",
    "unassigned": "Unassigned",
    "hint": "j/k move · Enter open · / search",
    "sort": "Sort by",
    "title_mentioned": "Mentioned",
    "title_snoozed": "Snoozed",
    "select_ticket": "Select ticket {{id}}",
    "selected_count": "{{count}} selected",
    "cards_count": "{{count}} tickets",
    "chip_snoozed": "⏰ snoozed",
    "chip_urgent": "Urgent",
    "chip_delivery_failed": "Delivery failed",
    "triage_note": "AI guessed team {{team}} · confidence {{confidence}}",
    "triage_tag": "Triage",
    "delivery_tag": "Delivery",
    "wait_prefix": "waiting",
    "layout_list": "List",
    "save_as_view": "Save as view",
    "wake_prefix": "wakes",
    "edit_view": "Edit this view"
  },
  "sort": {
    "last_activity_desc": "Last activity",
    "created_desc": "Newest first",
    "due_asc": "Due soonest",
    "priority_desc": "Highest priority"
  },
  "ticket": {
    "copy_id": "Copy ticket ID",
    "copied": "Copied",
    "claim": "Claim",
    "transition": "Change status",
    "reply": "Reply",
    "note": "Internal note",
    "send": "Send",
    "add_note": "Save note",
    "placeholder_reply": "Write a reply to the customer…",
    "placeholder_note": "Write an internal note (customers cannot see this)…",
    "conflict": "The ticket changed while you were typing — reload",
    "reload": "Reload",
    "internal": "Internal note",
    "system": "System",
    "holder": "Holder",
    "requester": "Requester",
    "no_messages": "No messages yet",
    "attachments": "{{count}} attachments",
    "send_shortcut": "⌘/Ctrl+Enter to send",
    "cannot_compose": "You cannot write on this ticket",
    "not_found": "Ticket not found",
    "quoted": "Quoted message",
    "scheduled_for": "Scheduled to send {{when}}",
    "cancel_schedule": "Cancel scheduled send",
    "sent_at": "Sent",
    "delivery_queued": "Queued",
    "delivery_sent": "Sent",
    "delivery_delivered": "Delivered",
    "delivery_bounced": "Bounced",
    "delivery_failed": "Failed",
    "delivery_complaint": "Complained",
    "back": "Back",
    "claim_card": "Claim ticket",
    "edit_subject": "Edit subject",
    "menu": "Ticket menu",
    "due_label": "Due",
    "conflict_typing": "This ticket was edited while you were typing — your draft is kept",
    "kind_customer": "Customer",
    "kind_reply": "Reply to customer",
    "status": "Status",
    "attachments_count": "{{count}} attachments",
    "notes_count": "{{count}} notes",
    "watchers_count": "{{count}} watchers",
    "delivery_unknown": "Delivery outcome unknown (awaiting confirmation — no automatic resend)"
  },
  "composer": {
    "send": "Send",
    "send_close": "Send & Close",
    "schedule": "Schedule…",
    "send_at": "Send at",
    "schedule_confirm": "Schedule send",
    "schedule_required": "Please pick a date and time",
    "schedule_future": "Time must be in the future",
    "schedule_too_far": "Cannot schedule more than 30 days ahead",
    "schedule_email_off": "Scheduled sending requires email on — enable \"Also notify requester by email\" first, otherwise the request will be rejected",
    "more_send_options": "More send options",
    "mentions": "Mentions",
    "mention_remove": "Remove {{name}} from mentions",
    "kb_hint": "Type /kb to search articles",
    "kb_links": "Attached articles",
    "kb_remove": "Remove {{title}}",
    "kb_results": "KB search results",
    "send_if_no_reply": "Send only if customer hasn't replied",
    "snooze_until": "Snooze until",
    "snooze_send": "Send & snooze",
    "snooze_send_confirm": "Send and snooze",
    "to": "To",
    "cc": "Cc",
    "add_to": "Add recipient",
    "add_cc": "Add cc",
    "remove_email": "Remove {{email}}",
    "ai_quiet": "Draft with AI"
  },
  "undo": {
    "sent": "Sent",
    "action": "Undo ({{count}})",
    "action_no_count": "Undo",
    "expired": "Undo window has expired",
    "countdown_secs": "undo for {{count}}s more"
  },
  "attach": {
    "add": "Attach files",
    "list": "Attachments to be sent",
    "uploading": "Uploading",
    "cancel": "Cancel upload",
    "remove": "Remove attachment",
    "cancelled": "Cancelled",
    "upload_failed": "Upload failed",
    "too_large": "File exceeds 25MB",
    "risky": "Risky file"
  },
  "handoff": {
    "button": "Hand off",
    "title": "Hand off ticket",
    "mode": "Mode",
    "mode_transfer": "Transfer",
    "mode_child": "Child ticket",
    "to_team": "To team",
    "select_team": "Select a team…",
    "note": "Message",
    "requested_action": "Requested action",
    "due_at": "Due",
    "submit": "Hand off",
    "return": "Send back",
    "error_team_required": "Please choose a destination team",
    "error_due_invalid": "Invalid date",
    "teams_unavailable": "Could not load teams",
    "section": "Section",
    "tab_details": "Details",
    "tab_redaction": "Redact",
    "redaction_help": "Pick text/attachments/emails to redact before handoff — the destination team won't see them until they click \"View\" and give a reason",
    "dept_unknown": "Department",
    "dept_intake_missing": "no intake team yet — pick a team directly"
  },
  "watchers": {
    "label": "{{count}} watchers",
    "follow": "Watch",
    "unfollow": "Unwatch"
  },
  "panel": {
    "title": "Ticket details",
    "toggle": "Toggle details panel",
    "subject": "Subject",
    "priority": "Priority",
    "due": "Due",
    "clear_due": "Clear due date",
    "tags": "Tags",
    "no_tags": "No tags",
    "add_tag": "Add tag",
    "add_tag_placeholder": "Tag name…",
    "remove_tag": "Remove tag {{tag}}",
    "tags_not_ready": "Tag list not ready yet",
    "custom_fields": "Custom fields",
    "no_custom_fields": "No custom fields",
    "save_fields": "Save fields",
    "info": "Info",
    "service": "Service",
    "channel": "Channel",
    "language": "Language",
    "version": "Version",
    "tab_details": "Details",
    "tab_ai": "AI",
    "tab_context": "Customer data",
    "field_select_empty": "— pick —",
    "field_no_options": "no options defined"
  },
  "priority": {
    "low": "Low",
    "normal": "Normal",
    "high": "High",
    "urgent": "Urgent"
  },
  "search": {
    "label": "Search tickets",
    "placeholder": "Search… (status:open tag:vpn is:mine)",
    "clear": "Clear search",
    "results_for": "Results for: {{q}}",
    "unsupported_keys": "Unsupported filters: {{keys}} — not sent to search"
  },
  "views": {
    "saved": "Saved views",
    "not_ready": "Saved views not ready yet",
    "save": "Save view",
    "save_current": "Save current search as a view",
    "save_need_q": "Type a query first to save a view",
    "save_name_prompt": "Name this view",
    "pin": "Pin",
    "unpin": "Unpin",
    "create": "New view",
    "name": "Name",
    "layout": "Layout",
    "layout_list": "List",
    "layout_kanban": "Kanban",
    "share_team": "Share with team",
    "private": "Private (not shared)",
    "shared_badge": "Shared",
    "edit": "Edit view",
    "layout_calendar": "Calendar",
    "scope": "View scope",
    "field_scope": "Scope",
    "field_team": "Team",
    "field_q": "Search",
    "field_status": "Status",
    "field_sort": "Sort",
    "scope_all": "All tickets",
    "scope_mine": "Mine",
    "scope_team_unassigned": "Team — unassigned",
    "scope_team_all": "Team — all",
    "scope_watching": "Watching",
    "status_open": "Open",
    "status_pending_customer": "Waiting customer",
    "status_pending_internal": "Waiting internal",
    "status_resolved": "Resolved",
    "status_closed": "Closed"
  },
  "portal": {
    "my_cases": "My cases",
    "no_cases": "No cases yet",
    "filter_placeholder": "Filter by subject/ID…",
    "track": "Track a case",
    "guest_banner": "Sign in with UWU ID to see all your cases in one place",
    "steps": "Progress",
    "change_status": "Change case status",
    "back_to_my": "Back to my cases",
    "send_failed": "Couldn't send your message — your draft and attachments are kept. Please try sending again.",
    "attach_retry": "Retry upload",
    "attach_error_blocked": "Some attachments aren't ready — retry the upload or remove the files before you can send.",
    "draft_locked": "This case is now closed — your draft and attachments are kept. Press 'Reopen this case' to send them, or copy your message into a new case."
  },
  "guest": {
    "title": "Open your case",
    "intro": "We will email a 6-digit verification code to the address associated with this link",
    "request_otp": "Send verification code",
    "enter_code": "Enter verification code",
    "code_hint": "Enter the 6-digit code from the email",
    "verify": "Verify",
    "resend": "Resend code",
    "wrong_code": "Incorrect code",
    "rate_limited": "Too many requests — please wait",
    "locked": "Too many attempts — locked for 15 minutes",
    "link_linked": "This email is linked to an account — please sign in",
    "verify_unavailable": "Link verification is not available in this environment yet"
  },
  "track": {
    "title": "Track a case by ID",
    "ticket_id": "Case ID",
    "email": "Email used to open the case",
    "submit": "Send tracking link",
    "sent": "If a case matches this information, we will email you a link",
    "hint": "Email-based tracking confirms your identity without exposing case status to others"
  },
  "event": {
    "status_changed": "Status changed",
    "handoff_sent": "Ticket handed off",
    "handoff_received": "Received handed-off ticket",
    "handoff_returned": "Ticket sent back",
    "watcher_added": "Watcher added",
    "watcher_removed": "Watcher removed",
    "mention": "Mentioned",
    "tag_added": "Tag added",
    "tag_removed": "Tag removed",
    "priority_changed": "Priority changed",
    "due_changed": "Due date changed",
    "field_changed": "Field changed",
    "child_created": "Child ticket created",
    "email_sent": "Email sent",
    "email_bounced": "Email bounced",
    "due_soon": "Due soon",
    "overdue": "Overdue",
    "automation_actor": "Automation",
    "snoozed": "Snoozed",
    "unsnoozed": "Unsnoozed",
    "merged": "Merged",
    "split": "Split",
    "linked": "Linked",
    "unlinked": "Unlinked",
    "redacted": "Redacted",
    "redaction_revealed": "Redaction revealed",
    "automation_ran": "Automation ran",
    "automation_error": "Automation error"
  },
  "safeHtml": {
    "show_external_image": "Show external image"
  },
  "new": {
    "title": "New ticket",
    "service": "Service",
    "service_placeholder": "Select a service",
    "requester_email": "Requester email",
    "requester_name": "Requester name",
    "subject": "Subject",
    "body": "Details",
    "submit": "Create ticket",
    "submitting": "Creating…"
  },
  "profile": {
    "title": "Profile",
    "needs_profile": "Please set a display name before continuing",
    "display_name": "Display name",
    "locale": "Language",
    "timezone": "Timezone",
    "save": "Save",
    "saved": "Saved",
    "email": "Email"
  },
  "theme": {
    "toggle": "Toggle theme",
    "system": "System",
    "light": "Light",
    "dark": "Dark"
  },
  "lang": {
    "toggle": "Toggle language",
    "th": "ไทย",
    "en": "English"
  },
  "palette": {
    "title": "Commands",
    "placeholder": "Type to search commands…",
    "empty": "No commands found",
    "go_inbox": "Go to My Inbox",
    "go_all": "Go to All tickets",
    "go_profile": "Go to Profile",
    "new_ticket": "New ticket",
    "go_mail": "Go to my mail",
    "mail_settings": "Mail settings",
    "mail_quarantine": "Quarantined mail"
  },
  "common": {
    "working": "Working…",
    "refreshing": "Updating…",
    "loading": "Loading…",
    "error": "Something went wrong",
    "retry": "Retry",
    "cancel": "Cancel",
    "close": "Close",
    "saving": "Saving…",
    "not_ready": "This feature is not ready yet",
    "save": "Save",
    "add": "Add",
    "edit": "Edit",
    "delete": "Delete",
    "confirm_delete": "Delete this item?",
    "actions": "Actions",
    "empty": "No items",
    "copy": "Copy",
    "copied": "Copied",
    "unsaved_confirm": "Close without saving? Unsaved changes will be lost.",
    "mutation_failed": "Save failed"
  },
  "time": {
    "now": "just now"
  },
  "presence": {
    "label": "{{count}} viewing this ticket",
    "offline": "Offline — falling back to auto-refresh",
    "typing_of": "{{name}} is typing…",
    "collision_warning": "{{names}} is also typing a reply — check before you send to avoid duplicates",
    "collision_chip": "Collision risk — someone is replying to this ticket",
    "viewing_count": "{{count}} viewing"
  },
  "notifications": {
    "bell": "Notifications ({{count}} unread)",
    "title": "Notifications",
    "mark_all_read": "Mark all read",
    "empty": "No notifications",
    "see_all": "See all",
    "unread_only": "Unread only"
  },
  "reauth": {
    "title": "Re-authenticate",
    "body": "This action needs a fresh sign-in for security — confirm, then repeat the action once you're back.",
    "confirm": "Re-authenticate"
  },
  "notifPrefs": {
    "title": "Notification preferences",
    "subtitle": "Pick the channels you want per event — unchecked = no delivery on that channel",
    "event": "Event",
    "digest": "Digest",
    "digest_none": "No digest",
    "digest_hourly": "Hourly",
    "digest_daily": "Daily",
    "quiet": "Quiet outside business hours (email/push)",
    "push_disabled": "Push notifications are temporarily disabled for this release — your saved preferences are kept and will apply once push is re-enabled",
    "business_hours_id": "Business hours id",
    "business_hours_id_placeholder": "Leave blank to use your team's",
    "business_hours": "Your business hours",
    "eventLabel": {
      "ticket.new_in_team_inbox": "New ticket in team inbox",
      "ticket.assigned_to_me": "Assigned to me",
      "ticket.handoff_received": "Handoff received",
      "ticket.returned": "Ticket returned",
      "message.customer_reply": "Customer replied",
      "message.agent_reply": "Agent replied",
      "message.note": "New note",
      "mention": "Mentioned",
      "ticket.status_changed": "Status changed",
      "ticket.due_soon": "Due soon",
      "ticket.overdue": "Overdue",
      "ticket.escalated": "Escalated",
      "ticket.child_closed": "Child ticket closed",
      "ticket.unsnoozed": "Ticket unsnoozed",
      "redaction.revealed": "Redaction revealed",
      "automation.notify": "Automation notification",
      "automation.error": "Automation error",
      "csat.received": "CSAT received",
      "mailbox.new_mail": "New mail",
      "outbox.delivery_failed": "Outbox delivery failed",
      "system.digest": "System digest",
      "dsar.due": "DSAR due",
      "side_conversation.replied": "Side conversation replied",
      "mail.quota_warning": "Mail quota warning",
      "mail.send_limit_exceeded": "Mail send limit exceeded",
      "mail.send_suspended": "Mail sending suspended",
      "task.assigned_to_me": "Task assigned to me",
      "task.mentioned": "Mentioned in a task",
      "task.comment_added": "Task comment added",
      "task.status_changed": "Task status changed",
      "task.due_soon": "Task due soon",
      "task.overdue": "Task overdue"
    }
  },
  "admin": {
    "title": "Admin",
    "not_admin": "This page is for admins only",
    "nav_services": "Services",
    "nav_mailboxes": "Mailboxes",
    "nav_teams": "Teams",
    "nav_departments": "Departments",
    "nav_users": "Users",
    "users_kind": "User kind",
    "users_status": "User status",
    "users_search": "Search by name or email",
    "users_pagination": "User list pagination",
    "users_previous": "Previous",
    "users_next": "Next",
    "users_page": "Page {{page}}",
    "users_page_size": "Up to 50 users per page",
    "nav_api_clients": "API clients",
    "nav_status_sets": "Status sets",
    "nav_priority_schemes": "Priority schemes",
    "nav_automation": "Automation",
    "nav_business_hours": "Business hours",
    "nav_templates": "Templates",
    "nav_settings": "Settings",
    "nav_audit": "Audit log",
    "nav_webhooks": "Webhooks",
    "nav_forms": "Forms",
    "not_ready": "Waiting on batch B backend (T-032/T-034) to merge — API not on main yet",
    "nav_field_definitions": "Custom fields",
    "nav_tags": "Tags",
    "nav_holiday_calendars": "Holiday calendars",
    "fd": {
      "key": "Key",
      "label": "Label",
      "type": "Type",
      "scope": "Scope",
      "scope_id": "Scope id (uuid)",
      "options": "Options (one per line)",
      "validation_regex": "Pattern (regex)",
      "validation_min": "Min length",
      "validation_max": "Max length",
      "visible_if": "Show when",
      "visible_if_invalid": "Invalid visibility condition",
      "customer_visible": "Customer visible",
      "customer_editable": "Customer editable",
      "show_in_list": "Show in list",
      "searchable": "Searchable",
      "sensitive": "Sensitive",
      "ai_extractable": "AI extractable",
      "sort_order": "Sort order",
      "flags": "Flags",
      "archived": "Archived",
      "active": "Active",
      "scope_global": "Global",
      "scope_service": "Service",
      "scope_team": "Team",
      "status": "Status",
      "err_scope_service": "Pick a service first (service scope requires a service)",
      "err_scope_team": "Pick a team first (team scope requires a team)",
      "err_visible_if_value": "Fill in the visibility condition value",
      "scope_service_target": "Service",
      "scope_team_target": "Team",
      "validation_preset": "Preset",
      "preset_none": "— pick to fill regex —",
      "vis_field": "Field to check",
      "vis_op": "Operator",
      "vis_value": "Value",
      "err_visible_if_between": "between needs two numbers separated by a comma, e.g. 10,60"
    },
    "tags": {
      "name": "Name",
      "color": "Color",
      "description": "Description",
      "pick_color": "Pick a color",
      "scope_filter_all": "All"
    },
    "holidays": {
      "name": "Name",
      "dates_label": "Holidays (YYYY-MM-DD one per line)",
      "import_thai": "Import Thai public holidays {{year}}",
      "invalid_date": "Invalid date format: {{line}}",
      "dates_count": "{{count}} days",
      "years": "Years",
      "dates": "Days"
    },
    "bh": {
      "holiday_calendar": "Holiday calendar",
      "no_calendar": "— None —",
      "timezone": "Timezone",
      "add_interval": "Add interval for {{day}}",
      "remove_interval": "Remove interval {{index}} of {{day}}",
      "interval_start": "{{day}} interval {{index}} start",
      "interval_end": "{{day}} interval {{index}} end",
      "days": {
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday",
        "sun": "Sunday"
      }
    },
    "teams": {
      "member_role": "Role",
      "role_of": "Role of {{name}}",
      "already_member": "This user is already a member of the team",
      "pick_user": "Pick a new member"
    },
    "dept": {
      "intake_team": "Intake team",
      "no_intake_team": "No intake team yet"
    },
    "svc": {
      "intake_team": "Intake team",
      "department": "Department",
      "status_set": "Status set",
      "priority_scheme": "Priority scheme",
      "none": "— none —"
    },
    "readiness": {
      "title": "Per-service readiness",
      "hint": "Computed from current settings — missing items link to their fix page",
      "ready": "Ready to receive cases",
      "not_ready": "Not ready ({{count}} missing)",
      "check_intake_team": "Intake team",
      "check_workflow": "Workflow",
      "check_priority": "Priority",
      "check_business_hours": "Business hours",
      "check_channels": "Intake channels",
      "fix": "Fix"
    },
    "ss": {
      "edit_title": "Rename status set",
      "edit_status": "Edit status {{code}}",
      "status_name": "Status name",
      "status_type": "Status type",
      "edit_transition": "Edit transition {{from}} → {{to}}",
      "transition_roles": "Allowed roles",
      "require_note": "Require note"
    },
    "ps": {
      "edit_title": "Rename priority scheme",
      "edit_priority": "Edit priority {{code}}",
      "priority_name": "Priority name",
      "priority_rank": "Rank"
    },
    "nav_kb": "Knowledge base",
    "nav_csat": "CSAT stats",
    "nav_ai": "AI settings",
    "nav_pdpa": "PDPA",
    "nav_feature_flags": "Feature flags",
    "nav_health": "System health",
    "nav_context_providers": "Context providers",
    "api_key_email_policy": {
      "read_title": "Email reading policy",
      "read_hint": "Read only this client’s messages matching both selected sender and stream. Applies to lists, details, receipts and events, independently of send permissions.",
      "read_senders": "Readable senders",
      "read_sender_hint": "Enter full sender addresses separated by newlines or commas, not recipient addresses.",
      "read_streams": "Readable streams",
      "read_prefix": "Read",
      "read_legacy": "Legacy reading: all messages of this client",
      "title": "Email sending policy",
      "hint": "Set permissions for this new key. Choose at least one sender and stream. Add email:read to inspect message status.",
      "senders": "Allowed senders",
      "sender_hint": "Enter full email addresses separated by newlines or commas. Senders must have a sending identity in the system.",
      "invalid_sender": "Enter valid email addresses. Wildcards are not supported in this form.",
      "streams": "Allowed streams",
      "sandbox": "Sandbox — test without sending real email",
      "live": "Live delivery",
      "live_hint": "This key allows real email delivery through the configured provider.",
      "sender_summary": "Senders",
      "none": "No email sending policy configured",
      "key_name": "Key name"
    },
    "api_client_services": {
      "title": "Services visible in feed/webhooks",
      "button": "Services",
      "hint": "The client sees tickets of the selected services across all channels (including customer-opened via portal/form) in addition to tickets it created itself — this scopes the change feed and webhooks",
      "empty": "No services selected — the client only sees tickets it created itself"
    },
    "nav_mail_admin": "Mail (admin)",
    "mail": {
      "title": "Mail admin console",
      "hint": "Manage mail platform domains, accounts, addresses and grants — permissions and validation are enforced by the backend",
      "tab_domains": "Domains",
      "tab_accounts": "Accounts",
      "tab_addresses": "Addresses",
      "tab_domain_admins": "Domain admins",
      "tab_routes": "Routes",
      "forbidden": "This section requires a system administrator (per backend guard)",
      "done": "Done",
      "col_domain": "Domain",
      "col_readiness": "Readiness",
      "col_ses": "SES",
      "col_cf": "Cloudflare",
      "col_catch_all": "Catch-all",
      "col_max_inbound": "Max inbound (MB)",
      "col_default_quota": "Default quota (MB)",
      "col_address": "Address",
      "col_display": "Display name",
      "col_status": "Status",
      "col_quota": "Quota",
      "col_send_limit": "Send limit/day",
      "col_kind": "Kind",
      "col_enabled": "Enabled",
      "col_target": "Target",
      "col_grants": "Grants",
      "col_user": "User",
      "col_pattern": "Pattern",
      "col_priority": "Priority",
      "ready": "Ready to send/receive",
      "not_ready": "Not ready",
      "w_ses": "SES verified (identity+DKIM)",
      "w_cf": "Cloudflare ready",
      "w_routing": "Routing enabled",
      "f_routing": "Enable routing",
      "f_catch_all": "Catch-all",
      "f_catch_all_none": "Off (none)",
      "f_catch_all_reject": "Reject",
      "f_catch_all_address": "Forward to address",
      "f_mta_sts_mode": "MTA-STS mode",
      "f_mta_sts_id": "MTA-STS id",
      "f_tlsrpt_rua": "TLSRPT rua",
      "f_dmarc_rua": "DMARC rua",
      "f_max_inbound": "Max inbound size (MB)",
      "f_default_quota": "Default quota (MB)",
      "f_local_part": "Local part (before @)",
      "f_domain": "Domain",
      "f_display_name": "Display name",
      "f_quota_mb": "Quota (MB)",
      "f_send_limit": "Send limit/day",
      "f_user": "User to bind",
      "f_user_hint": "Leave empty to pre-create for a new user via staff invite (team required)",
      "f_invite_team": "Invitee team",
      "f_invite_role": "Invitee role",
      "pending_bind": "Awaiting user bind",
      "provision": "Provision account",
      "suspend": "Suspend",
      "activate": "Reactivate",
      "offboard": "Offboard",
      "offboard_confirm": "Offboard this mail account? Its address is disabled immediately and the account enters the offboard flow",
      "status_active": "Active",
      "status_suspended": "Suspended",
      "status_offboarded": "Offboarded",
      "kind_group": "Group",
      "kind_shared_mailbox": "Shared mailbox",
      "kind_system": "System",
      "kind_account_hint": "Account addresses are created through account provisioning only",
      "alias_target_kind": "Target",
      "alias_to_account": "Forward to account",
      "alias_to_mailbox": "Forward to ticket mailbox",
      "members": "Group members",
      "member_kind": "Member kind",
      "member_account": "Mail account",
      "member_address": "Address",
      "add_member": "Add member",
      "remove_member": "Remove member",
      "send_as_policy": "Send-as policy",
      "send_as_members": "All members",
      "send_as_admins": "Admins only",
      "reply_to_group": "Reply-to the group",
      "handler": "System handler",
      "mailbox": "Ticket mailbox",
      "create": "Create address",
      "grants_title": "Address grants",
      "grant_add": "Add grant",
      "grant_account": "Mail account",
      "grant_rights": "Rights",
      "manage_grants": "Grants",
      "right_send_as": "Send as",
      "right_send_on_behalf": "Send on behalf",
      "right_read": "Read",
      "right_manage": "Manage",
      "da_grant": "Grant mail_admin",
      "da_revoke": "Revoke",
      "routes_hint": "View only — system routing table (not editable here)",
      "err_target_required": "Fill in the address target before saving",
      "err_grant_required": "Pick an account and at least one right"
    },
    "api_client_archive": "Archive API client",
    "api_client_archive_confirm": "Archive this API client and revoke all keys? Ticket and email history will be retained."
  },
  "board": {
    "title": "Board",
    "pick_view": "Pick a kanban saved view to see the board",
    "no_kanban_views": "No kanban saved views yet — create one from the sidebar first",
    "conflict": "This ticket changed — reload and try again",
    "transition_denied": "Can't move to this status (guard failed)",
    "empty": "No tickets in this view",
    "remaining": "{{count}} more not loaded",
    "loaded_of": "Loaded {{loaded}} of {{total}}"
  },
  "forms": {
    "select_placeholder": "— select —",
    "file_not_supported": "File upload isn't supported on this form yet",
    "otp_wrong": "Wrong code, try again",
    "success_title": "Submitted",
    "success_body": "Our team will get back to you soon",
    "track_link": "Track status",
    "guest_verify": "Verify your email before submitting",
    "email_placeholder": "Your email",
    "send_code": "Send code",
    "verify_code": "Verify code",
    "submit": "Submit",
    "otp_session_expired": "Your verification session expired. Please request a new code and verify again.",
    "otp_email_changed": "The email changed during verification. Please request a new code for the new email.",
    "session_expired": "Your session expired. Sign in again or verify your email with an OTP code to continue — your answers are kept.",
    "file_add": "Attach files",
    "file_add_aria": "Attach files for {{field}}",
    "file_list": "Attached files",
    "file_uploading": "Uploading…",
    "file_ready": "Ready",
    "file_retry": "Retry upload",
    "file_remove": "Remove file",
    "file_max_exceeded": "Too many files for this field",
    "file_pending_block": "Files still uploading — wait or remove before submitting",
    "file_ready_count": "{{count}} file(s) attached",
    "file_too_large": "File exceeds 25 MB",
    "file_upload_failed": "Upload failed",
    "col_name": "Form name",
    "col_status": "Status",
    "publish": "Publish",
    "submissions": "Submissions",
    "name_th": "Name (th)",
    "view_group": "Edit view",
    "view_builder": "Form builder",
    "view_json": "JSON",
    "builder_pane": "Form builder",
    "palette": "Add field",
    "add_field": "Add field",
    "page_n": "Page {{n}}",
    "no_pages": "No pages yet",
    "properties": "Field properties",
    "field_key": "Field key",
    "field_label": "Field label",
    "required": "Required",
    "map_to": "Map to",
    "map_to_none": "— no mapping —",
    "options": "Options",
    "option_value": "Option value",
    "option_label_th": "Option label (th)",
    "add_option": "Add option",
    "visible_if": "Show when",
    "vis_field": "Field to check",
    "vis_op": "Operator",
    "vis_value": "Value",
    "preview": "Preview (desktop)",
    "schema_json": "Schema (JSON — pages[].fields[])",
    "json_parse_error": "JSON parse failed — check brackets/quotes and try again",
    "json_shape_error": "Invalid schema: {{first}}",
    "err_service": "Pick a service first",
    "open_ticket": "Open ticket",
    "no_ticket": "No ticket",
    "palette.text": "Text",
    "palette.textarea": "Paragraph",
    "palette.email": "Email",
    "palette.phone": "Phone",
    "palette.number": "Number",
    "palette.date": "Date",
    "palette.select": "Dropdown",
    "palette.multiselect": "Multi-select",
    "palette.radio": "Radio",
    "palette.checkbox": "Checkbox",
    "palette.consent": "Consent",
    "palette.ticket_ref": "Ticket reference",
    "palette.section": "Section",
    "palette.hidden": "Hidden",
    "palette.file": "File upload",
    "move_up": "Up",
    "move_down": "Down"
  },
  "snooze": {
    "title": "Snooze ticket",
    "preset_1h": "1 hour",
    "preset_tomorrow": "Tomorrow morning",
    "preset_next_week": "Next week",
    "until": "Snooze until",
    "submit": "Snooze",
    "error_required": "Pick a time first",
    "error_future": "Must be in the future",
    "error_too_far": "Snooze up to 90 days",
    "badge": "Snoozed until {{when}}",
    "cancel": "Cancel snooze",
    "scope": "Snooze scope",
    "scope_card": "Whole ticket",
    "scope_me": "Only me",
    "me_empty_hint": "No time = withdraw your personal snooze",
    "withdraw": "Withdraw"
  },
  "merge": {
    "title": "Merge ticket",
    "search_label": "Search destination ticket",
    "search_placeholder": "Subject or ticket id…",
    "error_required": "Pick a destination ticket first",
    "note": "This ticket (v{{version}}) will be merged into the ticket you pick — this can't be undone",
    "submit": "Merge"
  },
  "pickers": {
    "search": "Search by name…",
    "options": "Options",
    "type_more": "Type at least 2 characters to search",
    "no_match": "No results for this search",
    "load_error": "Couldn't load the list",
    "load_more": "Load more",
    "loading_more": "Loading more…",
    "loaded_count": "Showing {{count}} loaded",
    "showing_all": "All {{count}} items",
    "selected_count": "{{count}} selected",
    "remove": "Remove: {{label}}",
    "clear": "Clear selection",
    "user": {
      "label": "Select user",
      "placeholder": "Search people by name or email…"
    },
    "team": {
      "label": "Select team",
      "placeholder": "Search teams…",
      "no_department": "No department"
    },
    "department": {
      "label": "Select department",
      "placeholder": "Search departments…",
      "intake_ready": "Intake team set",
      "intake_missing": "No intake team yet"
    },
    "service": {
      "label": "Select service",
      "placeholder": "Search services…",
      "archived": "Archived"
    },
    "ticket": {
      "label": "Select ticket",
      "placeholder": "Subject or ticket id…"
    },
    "category": {
      "label": "Select category",
      "placeholder": "Search categories…",
      "none": "No parent category",
      "path": "Under: {{path}}",
      "self_or_descendant": "This category or its descendants"
    }
  },
  "split": {
    "title": "Split ticket",
    "select_messages": "Pick messages to move into a new ticket",
    "move_internal": "Actually move internal notes (not copy)",
    "error_required": "Pick at least one message",
    "submit": "Split"
  },
  "links": {
    "title": "Related tickets",
    "type_label": "Relation type",
    "target_placeholder": "Destination ticket id",
    "type": {
      "relates": "Relates to",
      "blocks": "Blocks",
      "blocked_by": "Blocked by",
      "duplicates": "Duplicates"
    },
    "blocked_warning": "This ticket is blocked by {{count}} other ticket(s) — close anyway?"
  },
  "redaction": {
    "view": "View",
    "reveal_title": "Confirm to view redacted content",
    "reason": "Reason",
    "reveal_submit": "View content",
    "reveal_not_found": "Couldn't find this redaction",
    "revealed": "Revealed",
    "countdown": "{{mm}}:{{ss}} left",
    "expired": "View window expired — refresh to view again",
    "candidates": "Auto-detected (tap to add)",
    "select_in_messages": "Drag-select text to redact that span",
    "attachments": "Attachments to hide",
    "participant_email": "Participant emails to hide",
    "error_reason_required": "Give a reason for the redaction first",
    "error_selection_single_message": "Select within a single message only"
  },
  "home": {
    "title": "How can we help?",
    "subtitle": "Search for answers yourself, or send a request — we reply within 1 business day",
    "search_placeholder": "Search for a solution…",
    "popular_categories": "Popular categories",
    "no_answer": "Still no answer?",
    "no_answer_body": "Send a request to the team, or check the status of an existing one",
    "new_ticket": "New request",
    "track_by_id": "Track by ID",
    "privacy": "Privacy policy",
    "sign_in": "Sign in",
    "article_count": "{{count}} articles",
    "top_articles": "Most read"
  },
  "catalog": {
    "choose_service": "Choose a service",
    "recommended": "Recommended",
    "empty_title": "No online request forms available right now",
    "empty_body": "If you need help, please reach us via the channels below",
    "contact_us": "Contact us"
  },
  "portalShell": {
    "profile": "Profile",
    "logout": "Sign out",
    "contact": "Contact",
    "staff_area": "Staff workspace"
  },
  "kb": {
    "title": "Title",
    "back": "Back",
    "results_for": "Results for “{{q}}”",
    "no_results": "No matching articles — try another term or send a request",
    "no_categories": "No categories yet",
    "updated_at": "Updated {{date}}",
    "read_minutes": "{{n}} min read",
    "helpful_q": "Was this article helpful?",
    "helpful_yes": "Helpful",
    "helpful_no": "Not really",
    "feedback_thanks": "Thanks for your feedback",
    "comment_placeholder": "Tell us what was missing (optional)",
    "comment_send": "Send feedback",
    "comment_skip": "Skip",
    "related": "Related articles",
    "still_need_help": "Still need help",
    "categories": "Categories",
    "cat_new": "New category",
    "cat_edit": "Edit category",
    "cat_name": "Category name",
    "slug": "slug",
    "visibility": "Visibility",
    "vis_public": "Public",
    "vis_authenticated": "Authenticated",
    "vis_staff": "Staff",
    "vis_team": "Team",
    "parent": "Parent",
    "sort": "Sort",
    "filter_status": "Filter status",
    "filter_category": "Category id (uuid)",
    "all_statuses": "All statuses",
    "article_new": "New article",
    "slug_taken": "This slug is already taken",
    "tz_label": "local time {{tz}}",
    "ai_stash_hint": "AI article draft ready: {{title}}",
    "editor": "Article editor",
    "status": "Status",
    "status_draft": "Draft",
    "status_review": "In review",
    "status_published": "Published",
    "status_archived": "Archived",
    "views": "Views",
    "helpful": "Helpful",
    "attach_count": "Attached",
    "publish_at": "Publish at",
    "expire_at": "Expire at",
    "tags": "Tags",
    "versions": "Versions",
    "version_new": "New version",
    "lang": "Language",
    "excerpt": "Excerpt",
    "body_html": "Body (HTML)",
    "machine_translated": "Machine translated",
    "machine_tag": "MT",
    "current": "current",
    "publish_version": "Publish",
    "no_versions": "No versions yet",
    "to_review": "Send to review",
    "to_published": "Publish article",
    "to_archived": "Archive",
    "preview": "Preview",
    "updated": "Updated",
    "no_articles_in_category": "No articles in this category yet",
    "category": "Category",
    "category_of_article": "Article category",
    "filter_category_label": "Filter by category",
    "add_child": "Add subcategory",
    "move": "Move",
    "move_category": "Move category",
    "delete_category": "Delete category",
    "cat_delete_confirm": "Delete category \"{{name}}\"?",
    "cat_move_hint": "Category \"{{name}}\" has {{articles}} articles and {{children}} subcategories — pick a destination; everything will be moved there before deletion",
    "move_target": "Move contents to",
    "move_and_delete": "Move & delete",
    "who_can_read": "Who can read",
    "who_public": "Everyone, including anonymous visitors",
    "who_authenticated": "Signed-in users only",
    "who_staff": "All staff",
    "who_team": "Members of the selected team only",
    "team_required": "Visibility = team requires a team before saving",
    "edit_content": "Edit content",
    "toolbar": "Formatting toolbar",
    "fmt_h2": "Heading 2",
    "fmt_h3": "Heading 3",
    "fmt_bold": "Bold",
    "fmt_italic": "Italic",
    "fmt_ul": "Bullet list",
    "fmt_ol": "Numbered list",
    "fmt_quote": "Quote",
    "fmt_link": "Link",
    "link_url_prompt": "Link URL:",
    "html_note": "HTML mode — edit raw tags anywhere (for experts)",
    "preview_draft": "Preview draft",
    "preview_lang": "Preview language",
    "preview_version": "Preview version",
    "archive_confirm": "Archive \"{{slug}}\"?\nThe article disappears from the public knowledge base and search; new versions/publishing are disabled — this cannot be undone",
    "archived_notice": "This article is archived — content edits and publishing are disabled",
    "review_permission_hint": "Publishing requires team lead/admin",
    "load_more": "Load more",
    "loaded_of_total": "Showing {{loaded}} of {{total}} articles",
    "matches": "{{count}} results",
    "showing_top": "Showing top {{shown}}"
  },
  "otp": {
    "title": "Enter the 6-digit code",
    "sent_to": "We sent a code to",
    "valid_minutes": "The code is valid for {{minutes}} minutes",
    "not_received": "Didn't get the code",
    "resend_in": "Resend available in {{time}}",
    "resend": "Resend code",
    "attempts_left": "{{count}} attempts left",
    "confirm_submit": "Verify and submit",
    "have_account": "Already have a UWU ID?",
    "login": "Sign in",
    "login_benefit": "to skip this step and see all your cases in one place",
    "input_label": "6-digit verification code",
    "edit_answers": "Edit answers before submitting"
  },
  "guest2": {
    "verify_title": "Confirm it's you to open this case",
    "intro_with_id": "This link came from a progress email about case {{id}}. For your security, we'll email you a verification code",
    "intro_no_id": "For your security, we'll email a verification code to the address that opened this case",
    "send_to": "Code will be sent to",
    "email_unknown": "The email used to open the case",
    "link_valid_hours": "This link is valid for {{hours}} hours and opens only this case and related ones",
    "expired_title": "This link has expired",
    "expired_body": "This link has expired or been revoked. Request a new one, or sign in to see your cases",
    "request_new": "Request a new link",
    "login_uwu": "Sign in with UWU ID"
  },
  "mycase": {
    "chip_all": "All {{count}}",
    "chip_active": "In progress {{count}}",
    "chip_closed": "Closed {{count}}",
    "st_received": "Received",
    "st_waiting": "Waiting for you",
    "st_working": "Team is on it",
    "st_closed": "Closed",
    "unread": "New reply",
    "team_line": "Team {{team}}",
    "updated_prefix": "Updated",
    "closed_prefix": "Closed",
    "csat_rated": "Rated {{score}}/{{max}}",
    "csat_until": "Rate by {{date}}",
    "new_ticket": "New request",
    "cared_by": "Handled by team {{team}} · opened {{date}}",
    "you": "You",
    "team_fallback": "Support team",
    "step_received": "Received",
    "step_claimed": "Team assigned",
    "step_working": "Team is on it",
    "step_done": "Resolved",
    "step_duration": "took {{duration}}",
    "step_started": "Started {{date}} · {{duration}} elapsed",
    "step_todo": "Not there yet",
    "composer_placeholder": "Write a message to the team…",
    "add_cc": "Add CC",
    "cc_placeholder": "CC emails (separate with , )",
    "close_self": "Close this case myself",
    "close_confirm": "Close this case?",
    "send": "Send",
    "send_message": "Send message",
    "rated": "Rated {{score}}/5",
    "rate_until": "You can rate until {{date}}",
    "chip_loaded": "{{count}} loaded"
  },
  "csat": {
    "title": "How well did our team help you?",
    "comment_placeholder": "Tell us what was good or what to improve (optional)",
    "submit": "Send rating",
    "note": "You can rate within 14 days after the case closes, and change it later",
    "thanks_title": "Thanks for your rating",
    "thanks_body": "Your feedback helps us improve",
    "comment_send": "Send feedback",
    "invalid": "This rating link is invalid or has expired",
    "team_id": "Team (uuid)",
    "since": "Since",
    "count": "{{count}} ratings",
    "responses": "Responses",
    "avg": "Average",
    "distribution": "Score distribution",
    "by_agent": "By agent",
    "agent": "Agent",
    "team": "Team"
  },
  "deflect": {
    "title": "These articles may answer your question right away",
    "continue_note": "If they don't match, just continue sending your request"
  },
  "submit2": {
    "next": "Next",
    "submit": "Submit",
    "email_invalid": "Invalid email format",
    "no_attach": "File attachments aren't supported yet",
    "otp_email_label": "Email for the verification code",
    "otp_title": "Verify your email"
  },
  "track2": {
    "desc": "No sign-in needed — we'll email you a link to open the case",
    "submit": "Email me the link",
    "nondisclosure": "If a case matches this information, we'll email you within a few minutes. The system never reveals whether a case exists"
  },
  "ai": {
    "sentiment_section": "Sentiment/Urgency",
    "sentiment_neg": "Negative",
    "sentiment_neu": "Neutral",
    "sentiment_pos": "Positive",
    "urgency": "Urgency",
    "urgency_low": "Low",
    "urgency_med": "Medium",
    "urgency_high": "High",
    "frustration": "Frustration signals",
    "summary": "Ticket summary",
    "summary_refresh": "Refresh summary",
    "cached": "cached",
    "waiting_on": "Waiting on",
    "next_steps": "Next steps",
    "error": "AI is unavailable right now",
    "draft": "Draft reply",
    "tone": "Tone",
    "tone_polite": "Polite",
    "tone_short": "Short",
    "tone_formal": "Formal",
    "draft_generate": "Generate draft",
    "draft_insert": "Insert into composer",
    "draft_disclaimer": "AI draft — review before sending",
    "draft_badge": "AI draft — review before sending",
    "draft_badge_clear": "Clear AI draft badge",
    "kb_refs": "Referenced articles",
    "extracted": "AI-extracted fields",
    "extracted_confirm": "Confirm",
    "extracted_done": "Saved",
    "translated_by": "Translated by AI",
    "translate_to": "Translate to {{lang}}",
    "translate_show": "Show translation",
    "translate_hide": "Hide translation",
    "kb_draft": "Convert to KB article",
    "duplicates_found": "Found {{count}} possible duplicate tickets",
    "budget_usd_month": "Monthly budget (USD)",
    "features": "Features",
    "feature": "Feature",
    "model": "Model",
    "threshold": "Threshold",
    "enabled": "Enabled",
    "settings_hint": "Leave empty = system default · disable a feature = skip all its calls",
    "panel_title": "AI draft",
    "insert_reply": "Insert into reply",
    "redraft": "Regenerate"
  },
  "triage": {
    "title": "Triage",
    "feature_disabled": "Triage inbox feature is disabled — enable it on the feature flags page",
    "reason": "AI reason",
    "no_reason": "No reason available",
    "rule_ai": "AI suggested this team",
    "rule_email": "Email rule",
    "rule_manual": "Manual",
    "alternatives": "Alternatives",
    "move_to": "Move to team",
    "stay_team": "Keep current team",
    "accept": "Accept",
    "decline": "Forward",
    "decline_submit": "Forward",
    "to_team": "To team",
    "note": "Note",
    "duplicate": "Duplicate",
    "duplicate_of": "Duplicates ticket",
    "duplicate_submit": "Mark duplicate",
    "team_filter": "Filter by team",
    "all_my_teams": "All my teams",
    "count": "{{count}} tickets"
  },
  "calendar": {
    "title": "Calendar",
    "pick_view": "Pick a saved view (layout = calendar)",
    "no_views": "No calendar views yet",
    "week_of": "Week of {{date}}",
    "prev": "Previous",
    "next": "Next",
    "today": "Today",
    "mode": "Mode",
    "mode_month": "Month",
    "mode_week": "Week",
    "day_0": "Sun",
    "day_1": "Mon",
    "day_2": "Tue",
    "day_3": "Wed",
    "day_4": "Thu",
    "day_5": "Fri",
    "day_6": "Sat",
    "no_due": "No due date ({{count}})",
    "sheet": "Ticket details",
    "open_ticket": "Open ticket",
    "more": "+{{count}} more",
    "more_aria": "See all {{count}} tickets for this day",
    "agenda_title": "Agenda for {{date}}",
    "capped_notice": "Showing latest {{count}} — more remain"
  },
  "context": {
    "none": "No external provider data for this ticket",
    "error": "Error",
    "new_provider": "Add context provider",
    "name": "Name",
    "url": "URL",
    "secret": "Secret",
    "secret_keep": "Leave empty to keep current",
    "service_codes": "Service codes (comma)",
    "timeout_ms": "Timeout (ms)",
    "enabled": "Enabled",
    "status": "Last status",
    "has_secret": "Secret configured"
  },
  "pdpa": {
    "dsar": "DSAR requests",
    "retention": "Retention policy",
    "ropa": "ROPA",
    "incidents": "Security incidents"
  },
  "dsar": {
    "new": "New request",
    "detail": "Request detail",
    "subject": "Data subject",
    "subject_email": "Subject email",
    "subject_user_id": "Subject user id",
    "error_subject_required": "Provide either email or user id",
    "type": "Type",
    "type_access": "Access",
    "type_portability": "Portability",
    "type_rectify": "Rectify",
    "type_erase": "Erase",
    "type_restrict": "Restrict",
    "type_object": "Object",
    "type_withdraw_consent": "Withdraw consent",
    "status": "Status",
    "status_new": "New",
    "status_verifying": "Verifying",
    "status_in_progress": "In progress",
    "status_awaiting_approval": "Awaiting approval",
    "status_approved": "Approved",
    "status_delivered": "Delivered",
    "status_closed": "Closed",
    "status_rejected": "Rejected",
    "filter_status": "Filter status",
    "all_statuses": "All statuses",
    "source": "Source",
    "source_manual": "Manual",
    "source_portal": "Portal",
    "source_idp": "IdP",
    "source_email": "Email",
    "due": "Due",
    "notes": "Notes",
    "note": "Note",
    "note_placeholder": "Note (optional)",
    "transition_to": "Transition to",
    "export": "Export data",
    "export_status": "Export status",
    "download": "Download",
    "link_pending": "Link is being prepared (check again later)",
    "anonymize_dry_run": "Anonymize dry-run",
    "anonymize_run": "Run anonymize",
    "anonymize_confirm": "Confirm real anonymization? This cannot be undone",
    "dry_run_summary": "Dry-run summary",
    "run_summary": "Anonymize summary",
    "scheduled": "follow-up scheduled in background",
    "discovery": "Discovered data of this subject",
    "disc_users": "Users",
    "disc_emails": "Emails",
    "disc_tickets": "Tickets",
    "disc_messages": "Messages",
    "disc_attachments": "Attachments",
    "disc_guest_links": "Guest links",
    "disc_sessions": "Sessions",
    "disc_consents": "Consents",
    "disc_csat": "CSAT"
  },
  "retention": {
    "enabled": "Enable scheduled deletion (off = dry-run only)",
    "suspended_emails_days": "Suspended emails (days)",
    "audit_days": "Audit log (days)",
    "api_logs_days": "API log (days)",
    "guest_link_days": "Guest links (days)",
    "ai_logs_days": "AI log (days)",
    "notifications_days": "Notifications (days)",
    "cron_runs_days": "Cron log (days)",
    "closed_after_days": "Closed tickets (days)",
    "closed_action": "Action",
    "dry_run": "Dry-run",
    "dry_run_result": "Dry-run result"
  },
  "ropa": {
    "hint": "Record of Processing Activities — generated from current services/forms/mailboxes",
    "download": "Download ROPA (markdown)"
  },
  "incidents": {
    "new": "Report incident",
    "description": "Description",
    "affected_scope": "Affected scope",
    "risk": "Risk",
    "risk_low": "Low",
    "risk_medium": "Medium",
    "risk_high": "High",
    "risk_critical": "Critical",
    "status": "Status",
    "status_open": "Open",
    "status_contained": "Contained",
    "status_closed": "Closed",
    "status_of": "Status of {{id}}",
    "detected_at": "Detected at",
    "pdpc_deadline": "PDPC deadline",
    "mark_pdpc_notified": "Mark PDPC notified"
  },
  "flags": {
    "hint": "Known flag keys (no list API — keys fixed on the web) · rules: users ∋ me or teams ∩ my teams or percent (per-user hash)",
    "on": "on",
    "off": "off",
    "enabled": "Enabled",
    "percent": "Percent",
    "teams": "Teams",
    "users": "Users",
    "summary_on": "Enabled",
    "summary_off": "Disabled",
    "summary_percent": "{{percent}}% rollout",
    "summary_teams": "Teams: {{teams}}",
    "summary_users": "Users: {{users}}",
    "summary_everyone": "Applies to everyone per the on/off state above",
    "desc": {
      "triage.inbox": "Triage inbox before tickets reach teams",
      "ai.pii_ner": "AI PII detection",
      "ai.auto_translate": "AI auto translation",
      "kb.public_indexable": "Allow search engines to index public KB pages"
    }
  },
  "health": {
    "db_ms": "DB latency",
    "ai_spend": "AI spend this month",
    "version": "Version",
    "queues": "Queues",
    "queue_inbound_backlog": "Inbound backlog",
    "queue_outbox_queued": "Outbox queued",
    "queue_outbox_failed_24h": "Failed (24h)",
    "queue_domain_events_unpublished": "Unpublished events",
    "cron": "Cron jobs",
    "task": "Task",
    "schedule": "Schedule",
    "last_status": "Last status",
    "last_ok_at": "Last ok",
    "failures_24h": "Failures (24h)",
    "run": "Run",
    "not_acquired": "Not acquired (another instance ran)"
  },
  "telegram": {
    "title": "Telegram notifications",
    "not_linked": "Not connected",
    "verified": "Connected (chat {{chat}})",
    "link_button": "Connect Telegram",
    "open_bot": "Open bot chat",
    "expires_in": "Link expires in ~{{sec}} min",
    "unlink": "Disconnect"
  },
  "filter": {
    "add": "+ Filter",
    "remove": "Remove filter {{token}}",
    "field": "Filter field",
    "value": "Filter value",
    "apply": "Add"
  },
  "bulk": {
    "claim": "Claim",
    "transfer": "Transfer",
    "status": "Status",
    "priority": "Priority",
    "tags": "Tags",
    "snooze": "Snooze",
    "close": "Close",
    "working": "Working…",
    "unavailable": "Unavailable — bulk actions are not supported yet",
    "result_ok": "{{ok}} succeeded",
    "result_failed": "{{failed}} failed",
    "failed_toggle": "Failed ({{count}})",
    "tag_add": "Add tag",
    "tag_placeholder": "Tag name…",
    "snooze_submit": "Snooze",
    "transfer_note": "Note to the target team (optional)"
  },
  "shortcut": {
    "title": "Keyboard shortcuts",
    "nav": "Navigation",
    "action": "Actions",
    "other": "Other",
    "rows": {
      "move": "Move between rows",
      "open": "Open ticket",
      "search": "Focus search",
      "palette": "Command palette",
      "select": "Toggle row selection",
      "select_all": "Select all on page",
      "clear": "Clear selection",
      "close": "Close ticket",
      "claim": "Claim ticket",
      "snooze": "Snooze ticket",
      "reply": "Focus reply box",
      "send": "Send",
      "ai_draft": "AI draft"
    }
  },
  "draft": {
    "saved_at": "Draft autosaved {{time}}"
  },
  "priorityLong": {
    "low": "Low",
    "normal": "Normal",
    "high": "High",
    "urgent": "Urgent"
  },
  "mobile": {
    "nav_label": "Mobile navigation",
    "tab_mine": "Mine",
    "tab_team": "Team",
    "tab_triage": "Triage",
    "tab_notifications": "Alerts",
    "select_view": "Choose view",
    "search": "Search",
    "swipe_hint": "Swipe row left to snooze · right to claim",
    "row_actions": "Row actions",
    "detail": "Details",
    "detail_title": "Ticket details",
    "status": "Status",
    "holder": "Holder",
    "due": "Due",
    "tags": "Tags",
    "attachments": "Attachments",
    "related": "Related tickets",
    "files_count": "{{count}} files",
    "cards_count": "{{count}} tickets",
    "change_status": "Change status",
    "merge_link": "Merge / link",
    "close_card": "Close ticket",
    "reply_customer": "Reply",
    "internal_note": "Internal note",
    "send_and_close": "Send & close",
    "composer_placeholder": "Write a reply to the customer…",
    "composer_note_placeholder": "Write an internal note…",
    "typing": "{{name}} is typing…",
    "draft_saved": "Draft saved",
    "ai_help": "AI assist",
    "attach": "Attach files",
    "send": "Send",
    "offline_banner": "Offline — refreshing every {{count}} seconds",
    "team_filter": "Team {{code}}",
    "urgent_first": "Urgent+",
    "longest_wait": "Longest wait",
    "empty_unassigned_title": "No unassigned tickets",
    "empty_unassigned_desc": "The queue is clear. Check tickets waiting on customers, or open a new ticket on their behalf",
    "empty_title": "No tickets in this view",
    "empty_desc": "Try another view or open a new ticket on the customer's behalf",
    "open_new_card": "New ticket",
    "view_team_queue": "View team queue",
    "view_card": "View",
    "snooze_button": "Snooze"
  },
  "t64": {
    "banner_team_title": "Our team is on it",
    "banner_team_body": "You don't need to do anything — the team will reply as soon as possible",
    "banner_customer_body": "The team is waiting for more information from you",
    "banner_customer_cta": "Go to the message box",
    "banner_closed_title": "This case is closed",
    "banner_csat_cta": "Rate this case",
    "chip_team": "Team is handling",
    "act_reply": "Reply",
    "act_close": "Close this case",
    "act_reopen": "Reopen this case",
    "act_cc": "Send a copy to someone else",
    "act_cc_help": "People you add will receive email updates about this case",
    "close_confirm_title": "Close this case?",
    "close_confirm_body": "If the problem comes back, you can reopen this case later",
    "close_confirm_days": "Reopening is allowed within {{days}} days after closing",
    "close_confirm_confirm": "Confirm close",
    "closed_panel_body": "This case is closed, so replies are turned off. If it is still not resolved, you can reopen this case or file a new one.",
    "closed_panel_reopen": "Reopen this case",
    "closed_panel_new": "Report a new issue",
    "closed_409": "This case was already closed (maybe from another tab) — the latest data has been loaded",
    "handoff_dept_whole": "Hand off to the whole department: {{dept}}",
    "handoff_my_team": "my team",
    "handoff_search_placeholder": "Search teams…",
    "handoff_no_dept": "No department",
    "redact_title": "Redact information in this message",
    "redact_action": "Redact personal data",
    "redact_help": "Select the text to redact or use a shortcut below, then give a reason",
    "redact_span": "Selected: characters {{start}}–{{end}}",
    "redact_add_item": "Add selected span",
    "redact_existing_title": "Already redacted (no need to redo)",
    "redact_revoke": "Unredact",
    "redact_revoke_403": "Only the person who marked this or an administrator can unredact it",
    "redact_submit": "Redact",
    "redact_done": "Information redacted",
    "composer_apply_menu": "Send & change status to…",
    "composer_apply_select": "Destination status",
    "composer_apply_none": "Keep current status",
    "composer_auto_status": "After sending, the system will automatically change it to {{status}}",
    "email_subject_target": "Email for account {{sub}} — resolved through UWU ID.",
    "email_notify_subject_label": "Email the requester through UWU ID",
    "email_unavailable": "No email route is available for the requester. You can still save a reply.",
    "email_reply_saved_failed": "Reply saved, but email could not be sent. Check the delivery status before continuing.",
    "email_notify_label": "Also notify the requester by email",
    "email_notify_off_hint": "No email — the requester will see this in the portal and get an in-app notification",
    "email_notify_warn": "This requester has no account to sign in with. Without an email they will not know you replied",
    "timeline_email_skipped": "No email sent",
    "timeline_redacted_badge": "Contains redacted data",
    "redact_scope_unsupported": "This server does not support hiding from everyone yet, so this message cannot be redacted (tell an admin)"
  },
  "reports": {
    "nav": "Reports",
    "title": "Reports",
    "tabs_label": "Report tabs",
    "schedules_link": "Scheduled reports",
    "schedules_title": "Scheduled reports",
    "preset_group": "Date range",
    "preset_7d": "7 days",
    "preset_30d": "30 days",
    "preset_90d": "90 days",
    "preset_custom": "Custom",
    "filter_from": "From",
    "filter_to": "To",
    "filter_team": "Team",
    "filter_team_all": "All visible teams",
    "filter_service": "Service",
    "filter_service_all": "All services",
    "filter_granularity": "Granularity",
    "gran_day": "Daily",
    "gran_week": "Weekly",
    "gran_month": "Monthly",
    "tab_overview": "Overview",
    "tab_volume": "Volume",
    "tab_response_times": "Response times",
    "tab_time_in_status": "Time in status",
    "tab_backlog": "Backlog",
    "tab_csat": "CSAT",
    "tab_agents": "Per-agent workload",
    "card_created": "Created",
    "card_resolved": "Resolved",
    "card_backlog": "Backlog now",
    "card_frt": "First response (median)",
    "card_frt_p90": "First response p90",
    "card_frt_business": "First response, business hours (median)",
    "card_resolution": "Resolution time (median)",
    "card_csat": "CSAT average",
    "card_bounces": "Email bounces",
    "card_scope": "Visible scope",
    "card_created_resolved": "Key numbers",
    "range_display": "Range {{from}} – {{to}} · Asia/Bangkok [from,to)",
    "delta_title": "Compared with previous equal-length period (API delta)",
    "empty_value": "No data in this range yet",
    "empty_data": "No data in this range yet",
    "business_median_short": "Business hours (median)",
    "business_p90_short": "Business hours p90",
    "business_source": "Source: ticket_state_periods.business_seconds",
    "unavailable_business": "Business-hours data unavailable — business_seconds missing for {{n}} tickets (unknown ≠ 0)",
    "csat_satisfied": "{{pct}}% satisfied from {{n}} responses",
    "csat_count": "Responses",
    "csat_pct": "Satisfied % (4-5)",
    "csat_by_team": "CSAT by team",
    "csat_no_team": "No team",
    "bounces_complained": "Complaints: {{n}}",
    "scope_org": "Whole organization",
    "scope_teams": "Per your permissions ({{n}} teams)",
    "volume_totals": "Totals: created {{created}} · resolved {{resolved}}",
    "backlog_asof": "As of {{as_of}}",
    "backlog_total": "Total backlog {{n}} tickets",
    "backlog_oldest": "Oldest {{days}} days",
    "backlog_bucket_days": "{{key}} days",
    "agents_unknown_note": "Merged-ticket closures are exact only where was_closed=false — {{n}} legacy merge events have unknown close state (not attributed to anyone)",
    "agents_nonuser_note": "{{n}} tickets closed by automation/system (not tied to a person)",
    "chart_table": "View as table",
    "chart_graph": "View as chart",
    "chart_max": "max",
    "chart_buckets": "buckets",
    "unit_minutes": "min",
    "unit_tickets": "tickets",
    "csv_download": "Download CSV",
    "csv_loading": "Preparing file…",
    "csv_done": "Downloaded",
    "csv_413": "File exceeds the size limit — narrow the date range or filter by team/service and try again",
    "csv_error": "Download failed, please retry",
    "loading": "Loading…",
    "error": "Failed to load report",
    "def_created": "Tickets created within the range (by creation date · Bangkok time)",
    "def_resolved": "Tickets closed within the range (by closed_at · Bangkok time)",
    "def_backlog": "Currently unclosed tickets — not a range metric",
    "def_frt": "Median time from creation to first response · Bangkok time · not an average",
    "def_frt_p90": "p90 of first response time (90% answered faster) · Bangkok time",
    "def_frt_business": "Same as FRT but counting business hours only, from ticket_state_periods.business_seconds",
    "def_resolution": "Median time from creation to closure · Bangkok time",
    "def_csat": "Average CSAT score 1-5 · satisfied % = scores 4-5 · grouped by ticket team",
    "def_bounces": "Bounces + complaints within the range — from outbox.message_events (bounced/complained)",
    "def_scope": "Data scope by role: staff see own teams · dept heads see their department · admins see everything",
    "def_created_resolved": "Summary of the selected range — toggle table to copy numbers",
    "def_volume_series": "Day/week (Monday)/month series in Bangkok time",
    "def_time_in_status": "Total time tickets spent per status, median per ticket (clamped to the selected range)",
    "def_backlog_buckets": "Currently unclosed tickets grouped by full-day age buckets (non-overlapping)",
    "def_backlog_note": "Age counted from creation to as_of · the [from,to) range does not affect current backlog",
    "def_agents": "Tickets closed in range + public replies per person · ticket team uses current holder (current_holder)",
    "table_day": "Day",
    "table_created": "Created",
    "table_resolved": "Resolved",
    "table_status": "Status",
    "table_tickets": "Tickets",
    "table_median": "Median (min)",
    "table_p90": "p90 (min)",
    "table_total_sec": "Total (sec)",
    "table_bucket": "Age bucket",
    "table_from_days": "From (days)",
    "table_to_days": "To (days)",
    "table_count": "Count",
    "table_team": "Team",
    "table_avg": "Avg",
    "table_satisfied": "Satisfied (%)",
    "table_agent": "Agent",
    "table_email": "Email",
    "table_closed": "Closed",
    "table_merged": "Closed via merge",
    "table_replies": "Public replies",
    "table_metric": "Metric",
    "table_value": "Value",
    "kind_overview": "Overview",
    "kind_volume": "Volume",
    "kind_response_times": "Response/resolution times",
    "kind_time_in_status": "Time in status",
    "kind_backlog": "Backlog",
    "kind_csat": "CSAT",
    "sch_create": "New scheduled report",
    "sch_empty": "No scheduled reports yet",
    "sch_name": "Name",
    "sch_kind": "Report",
    "sch_cadence": "Cadence",
    "sch_cadence_daily": "Daily",
    "sch_cadence_weekly": "Weekly",
    "sch_cadence_monthly": "Monthly",
    "sch_weekday": "Day of week",
    "sch_dom": "Day of month",
    "sch_day_of_month": "day {{day}}",
    "sch_hour_thai": "Send time (Bangkok)",
    "sch_hour_utc_hint": "will be sent at {{hour}}:00 UTC",
    "sch_format": "Email format",
    "sch_format_summary": "Summary in email",
    "sch_format_csv": "CSV attachment",
    "sch_recipients": "Recipients (staff emails, comma-separated)",
    "sch_recipients_hint": "Type an email or pick from suggestions (GET /api/v1/users) — every email must be a staff member (checked on save)",
    "sch_recipients_required": "At least one recipient email is required",
    "sch_recipients_invalid": "Some recipient emails are invalid",
    "sch_team_required": "Non-admin staff must pick one of their teams (org-wide = admin only)",
    "sch_team_staff_hint": "Org-wide scheduled reports are admin-only",
    "sch_save_error": "Save failed",
    "sch_submit": "Save",
    "sch_cancel": "Cancel",
    "sch_enabled": "Enabled",
    "sch_disabled": "Disabled",
    "sch_edit": "Edit",
    "sch_delete": "Delete",
    "sch_confirm_delete": "Delete this scheduled report?",
    "sch_last_run": "Last run: {{at}}",
    "sch_never": "never",
    "wd_0": "Sunday",
    "wd_1": "Monday",
    "wd_2": "Tuesday",
    "wd_3": "Wednesday",
    "wd_4": "Thursday",
    "wd_5": "Friday",
    "wd_6": "Saturday"
  },
  "t69": {
    "side_title": "Coordination",
    "side_ask": "Ask externally",
    "side_new": "Ask a department or contact",
    "side_customer_hidden": "Customers cannot see this message",
    "side_empty": "No coordination threads for this ticket",
    "side_open": "Open",
    "side_closed": "Closed",
    "side_last_reply": "Last reply",
    "side_back": "Back to threads",
    "side_section": "Coordination",
    "side_recipient_picker": "Find staff, team or department",
    "side_recipient_hint": "Teams and departments use their configured shared mailbox, or enter a contact email below.",
    "side_form_to": "To (email)",
    "side_form_cc": "Cc",
    "side_form_subject": "Subject",
    "side_form_body": "Message",
    "side_form_send": "Send",
    "side_form_warn": "Warning: customers cannot see this message, and ticket content is not attached automatically — copy it yourself if needed",
    "side_reply_label": "Reply in coordination thread",
    "side_reply_send": "Reply in thread",
    "side_close_thread": "Close thread",
    "side_reopen_thread": "Reopen thread",
    "side_to_note": "Copy into internal note",
    "side_to_note_done": "Copied into internal note",
    "side_select_msg": "Select message",
    "side_dir_out": "We asked",
    "side_dir_in": "Replied",
    "approval_section": "Approvals on this ticket",
    "approval_bar": "Awaiting approval {{received}}/{{needed}}",
    "approval_sent": "Approval requested — waiting for {{n}} more",
    "approval_waiting_names": "Not decided yet: {{names}}",
    "approval_note": "Note (optional)",
    "approval_approve": "Approve",
    "approval_decline": "Decline",
    "approval_queue": "Awaiting my approval",
    "draft_conflict": "The draft on the server was changed elsewhere while you were typing",
    "draft_keep_mine": "Keep mine",
    "draft_use_server": "Use the server's",
    "draft_shared_by": "{{name}} is drafting a reply",
    "draft_on_server": "synced"
  },
  "w8wf": {
    "needs_approval": "(needs approval)",
    "apply_pending": "Message sent — status changes after approval {{received}}/{{needed}}"
  },
  "mail": {
    "nav": "My email",
    "title": "My email",
    "not_found": "Page not found",
    "no_mailbox": "No mailbox for this account yet — contact an administrator to provision one",
    "forbidden": "You do not have access to this mailbox",
    "error_load": "Failed to load mail — please try again",
    "error_version": "This changed elsewhere while you were working — refresh and retry",
    "archived": "Archived",
    "unarchived": "Moved back to inbox",
    "trashed": "Moved to trash",
    "hint": "j/k move · Enter open · e archive · # trash · r reply · / search · l label",
    "select_hint": "Select a message from the list to read it",
    "labels": "Labels",
    "folders": {
      "group": "Folders",
      "inbox": "Inbox",
      "starred": "Starred",
      "sent": "Sent",
      "drafts": "Drafts",
      "archive": "Archive",
      "snoozed": "Snoozed",
      "trash": "Trash",
      "spam": "Spam"
    },
    "quota": {
      "label": "Storage",
      "used": "{{used}} MB of {{total}} MB used",
      "warn": "Storage almost full — clean up old mail or contact an admin"
    },
    "search": {
      "label": "Search mail",
      "placeholder": "Search mail… (e.g. from:customer label:VIP)",
      "clear": "Clear",
      "help": "Syntax",
      "help_title": "Available fields",
      "help_free": "Or type a free-text query (subject/body/sender)"
    },
    "list": {
      "empty": "No messages",
      "load_more": "Load more",
      "messages": "{{n}} messages",
      "starred": "Starred",
      "no_subject": "(no subject)"
    },
    "view": {
      "to": "to",
      "external": "Message from an external sender — beware links and attachments",
      "attachments": "Has attachments — download via the full .eml file",
      "raw": "Download (.eml)",
      "size": "{{kb}} KB",
      "reply": "Reply",
      "label": "Label",
      "archive": "Archive",
      "trash": "Trash",
      "back": "Back to list",
      "preview_only": "Preview — complete content appears after loading the original",
      "full_loading": "Loading complete original message…",
      "full_failed": "Failed to load original message",
      "retry_original": "Retry"
    },
    "picker": {
      "title": "Pick a label",
      "empty": "No labels yet (create them in mail settings)"
    },
    "account": {
      "switch_label": "Mailbox",
      "fallback_notice": "The selected mailbox is no longer available — switched back to your primary mailbox",
      "send_not_allowed": "You do not have permission to send mail or manage drafts in this mailbox"
    },
    "settings_link": "Settings",
    "quarantine_link": "Quarantine",
    "back_inbox": "Back to mailbox"
  },
  "m410": {
    "compose_title": "Compose",
    "from": "From",
    "to": "To",
    "cc": "Cc",
    "bcc": "Bcc",
    "on_behalf_of": "{{address}} (on behalf of)",
    "email_placeholder": "Type an email and press Enter",
    "remove": "Remove",
    "invalid_email": "Invalid email format",
    "subject": "Subject",
    "body": "Body",
    "body_placeholder": "Write your message…",
    "attach_signature": "Attach signature",
    "attach_quote": "Attach quoted message",
    "quote_preview": "Quoted message",
    "send": "Send",
    "schedule": "Schedule send",
    "send_at": "Send at",
    "schedule_send": "Schedule",
    "need_recipient": "At least one recipient is required",
    "need_send_at": "Send time is required",
    "draft_saved": "Draft saved",
    "draft_save_failed": "Failed to save draft",
    "send_failed": "Send failed",
    "undo_left": "Undo available for {{n}} seconds",
    "undo": "Undo",
    "undo_done": "Sending canceled",
    "undo_failed": "Undo failed",
    "loading": "Loading…",
    "load_failed": "Failed to load",
    "saved": "Saved",
    "save_failed": "Save failed",
    "delete": "Delete",
    "settings_title": "Mail settings",
    "signature_title": "Signature",
    "signature_label": "Signature (HTML)",
    "signature_placeholder": "<p>— Your name</p>",
    "signature_save": "Save signature",
    "autoreply_title": "Auto-reply",
    "autoreply_enable": "Enable auto-reply",
    "autoreply_from": "Start date",
    "autoreply_until": "End date",
    "autoreply_subject": "Auto-reply subject",
    "autoreply_body_external": "External message",
    "autoreply_body_internal": "Internal message",
    "autoreply_save": "Save auto-reply",
    "autoreply_need_dates": "Start and end dates are required",
    "autoreply_bad_range": "End date must be after start date",
    "labels_title": "Labels",
    "labels_name": "Label name",
    "labels_add": "Add label",
    "labels_empty": "No labels yet",
    "filter_title": "Mail filters",
    "filter_new": "Add new filter",
    "filter_op": "Match",
    "filter_op_and": "All (AND)",
    "filter_op_or": "Any (OR)",
    "filter_field": "Field",
    "filter_match": "Match type",
    "filter_value": "Value",
    "filter_size_op": "Greater/less than",
    "filter_date_op": "Before/after",
    "filter_date_value": "Date & time",
    "filter_add_condition": "Add condition",
    "filter_actions": "Actions",
    "filter_save": "Save filter",
    "filter_enabled": "Enable filter",
    "filter_need_condition": "At least one condition is required",
    "filter_need_action": "At least one action is required",
    "filter_condition_value_required": "Every selected condition needs a value",
    "filter_action_value_required": "Every selected action needs a value",
    "filter_empty": "No filters yet",
    "field_from": "From",
    "field_to": "To",
    "field_cc": "Cc",
    "field_subject": "Subject",
    "field_body": "Body",
    "field_attachment_name": "Attachment name",
    "field_size": "Size (bytes)",
    "field_has_attachment": "Has attachment",
    "field_is_external": "External sender",
    "field_spam_score_gte": "Spam score ≥",
    "field_label": "Label",
    "field_received_at": "Received at",
    "match_contains": "contains",
    "match_equals": "equals",
    "match_regex": "regex",
    "match_starts": "starts with",
    "match_ends": "ends with",
    "match_before": "before",
    "match_after": "after",
    "value_true": "Yes",
    "value_false": "No",
    "action_mark_read": "Mark as read",
    "action_star": "Star",
    "action_mark_important": "Important",
    "action_archive": "Archive",
    "action_trash": "Move to trash",
    "action_quarantine": "Quarantine",
    "action_snooze": "Snooze",
    "action_notify": "Notify",
    "action_stop": "Stop processing",
    "action_add_label": "Add label",
    "action_remove_label": "Remove label",
    "action_forward_internal": "Forward internally",
    "action_auto_reply_template": "Reply with template",
    "action_convert_to_ticket": "Convert to ticket",
    "param_label_name": "Label name",
    "param_snooze_hours": "Hours",
    "param_forward_address": "Forward address",
    "param_template_id": "Template id",
    "param_convert_codes": "service:team codes",
    "convert_placeholder": "SERVICE:TEAM",
    "quarantine_page_title": "Quarantine",
    "quarantine_title": "Quarantined messages",
    "quarantine_preview": "Preview",
    "quarantine_release": "Release",
    "quarantine_not_spam": "Not spam",
    "quarantine_released": "Released from quarantine",
    "quarantine_expires": "Expires",
    "quarantine_empty": "No items",
    "quarantine_no_preview": "(no preview content)",
    "unknown_sender": "(unknown sender)",
    "no_subject": "(no subject)",
    "filter_edit": "Edit",
    "filter_editing": "Edit filter",
    "filter_move_up": "Move up",
    "filter_move_down": "Move down",
    "filter_updated": "Filter updated",
    "labels_rename": "Rename",
    "labels_rename_save": "Save name",
    "labels_rename_cancel": "Cancel rename",
    "undo_pending": "Cancelling send — the system is stopping delivery; check the Sent folder for the result",
    "send_cancel_window_passed": "Cancel requested too late — the email is already being sent",
    "send_cycle_active": "This draft has an unfinished (or uncertain-outcome) send — wait for the result or a successful cancel before sending again"
  },
  "t92": {
    "pinned": "Pinned",
    "pin": "Pin",
    "unpin": "Unpin",
    "bcc": "Bcc",
    "add_bcc": "Add bcc",
    "bcc_invalid": "Invalid email address",
    "email_off_drop": "Email notify is off — selected bcc, sending mailbox, and signature choice will not be sent (rejected for no-email messages)",
    "from": "From",
    "from_label": "Sending mailbox",
    "from_default": "Ticket mailbox (default)",
    "from_mine": "you can send",
    "signature": "Signature",
    "signature_label": "Reply signature",
    "signature_auto": "Auto — append to email",
    "signature_inline": "Include in message body",
    "signature_none": "No signature",
    "signature_none_unsupported": "The current contract cannot express this yet — the server still appends your saved signature",
    "signature_inline_preview": "Signature will be appended to the body (server won't duplicate)",
    "signature_inline_clear": "Stop including signature in body"
  },
  "uxc2": {
    "priority_load_error": "Could not load priority options for this service",
    "fields_load_error": "Could not load field definitions",
    "field_sensitive": "Sensitive data",
    "field_undefined": "no definition",
    "bulk_priority_unavailable": "Selected tickets use different priority schemes (or options are unavailable) — select a single ticket or same-service tickets first",
    "transition": {
      "title": "Change status to “{{status}}”",
      "note_label": "Note (saved as internal note)",
      "required_mark": "*",
      "required_fields": "Fields required before this transition",
      "field_required": "This field is required before changing status",
      "approval_hint": "This transition requires approval — confirming will create an approval request; the status stays unchanged until approved",
      "children_hint": "All child tickets must be closed first (the server checks again)",
      "stale": "The ticket changed while you were filling this in — your inputs are kept; press “Reload” then confirm again",
      "reload": "Reload",
      "submit": "Confirm status change"
    }
  },
  "auto": {
    "col_name": "Rule name",
    "col_when": "When",
    "col_enabled": "Enabled",
    "priority": "Run order",
    "enabled": "Enabled",
    "toggle": "Toggle",
    "stop_processing": "Stop after this rule",
    "business_time": "Business hours only",
    "move_up": "Up",
    "move_down": "Down",
    "when": "When",
    "if": "If",
    "then": "Then",
    "and_word": "and",
    "or_word": "or",
    "mode_group": "Edit mode",
    "mode_builder": "Rule builder",
    "mode_json": "Advanced JSON",
    "conditions_json": "Conditions (JSON)",
    "actions_json": "Actions (JSON)",
    "match_label": "Condition matching",
    "match_all": "Match all",
    "match_any": "Match any",
    "field": "Field",
    "op_label": "Operator",
    "action_label": "Action",
    "value": "Value",
    "value_to": "to",
    "value_multi_hint": "comma-separated values",
    "cond_empty": "All tickets (no conditions yet)",
    "add_condition": "Add condition",
    "add_action": "Add action",
    "action_empty": "No actions yet",
    "then_hint": "What to do when conditions match",
    "action_no_value": "No extra setting needed",
    "assign_mode_label": "Assignment mode",
    "assign_modes": {
      "specific": "Specific user",
      "round_robin": "Round robin",
      "unassign": "Unassign"
    },
    "recipient": "Recipient",
    "team": "Team",
    "note": "Note",
    "relative_minutes": "From now (minutes)",
    "minutes": "min",
    "boolean_true": "Yes",
    "boolean_false": "No",
    "tag_add_new": "Add new tag \"{{name}}\"",
    "err_name": "Rule name is required",
    "err_no_action": "At least one action is required",
    "err_no_value": "Fill in the condition value",
    "err_op_field": "Operator \"{{field}}\" is not valid for this field",
    "err_no_action_value": "Action value is incomplete",
    "err_handoff_target": "Pick a team or a recipient",
    "err_json": "Invalid JSON (conditions/actions)",
    "err_conditions_schema": "conditions schema: {{msg}}",
    "err_actions_schema": "actions schema: {{msg}}",
    "fields": {
      "custom": "Custom field",
      "service": "Service",
      "channel": "Channel",
      "status": "Status",
      "status_type": "Status type",
      "priority": "Priority",
      "holder_team": "Holding team",
      "holder_user": "Assignee",
      "tags": "Tags",
      "requester_email": "Requester email",
      "requester_domain": "Requester domain",
      "requester_kind": "Requester kind",
      "subject": "Subject",
      "body": "Body",
      "mailbox": "Mailbox",
      "age_minutes": "Ticket age (min)",
      "message_count": "Message count",
      "is_first_message": "Is first message",
      "previous_status": "Previous status",
      "inside_business_hours": "Inside business hours",
      "has_parent": "Has parent",
      "unclaimed_minutes": "Unclaimed (min)",
      "inactive_minutes": "Inactive (min)",
      "message_direction": "Message direction",
      "ai.category": "AI category",
      "ai.confidence": "AI confidence",
      "ai.sentiment": "AI sentiment",
      "ai.urgency": "AI urgency",
      "language": "Ticket language"
    },
    "ops": {
      "eq": "equals",
      "neq": "not equals",
      "in": "is one of",
      "nin": "is not one of",
      "contains": "contains",
      "regex": "matches regex",
      "gt": "greater than",
      "lt": "less than",
      "between": "between",
      "is_empty": "is empty",
      "is_not_empty": "is not empty"
    },
    "actions": {
      "set_status": "Set status to",
      "set_priority": "Set priority to",
      "add_tags": "Add tags",
      "remove_tags": "Remove tags",
      "assign": "Assign to",
      "handoff": "Hand off to",
      "escalate": "Escalate",
      "stop": "Stop processing further rules",
      "move_to_triage": "Move to triage",
      "set_due": "Set due",
      "set_field": "Set field",
      "notify": "Notify",
      "auto_reply": "Auto reply",
      "add_note": "Add note",
      "add_watcher": "Add watcher",
      "webhook": "Call webhook"
    },
    "triggers": {
      "ticket.created": "ticket is created",
      "message.created": "a message arrives",
      "ticket.status_changed": "status changes",
      "ticket.holder_changed": "assignee changes",
      "ticket.priority_changed": "priority changes",
      "ticket.tag_changed": "tags change",
      "ticket.field_changed": "a field changes",
      "ticket.child_closed": "a child ticket is closed",
      "time.inactive": "inactive for a while",
      "time.unclaimed": "unclaimed for a while",
      "time.due_approaching": "due date approaching",
      "time.overdue": "past due",
      "time.schedule": "on schedule",
      "ticket.csat_received": "CSAT received",
      "ai.classified": "AI classified",
      "side_conversation.replied": "side conversation replied"
    },
    "dry": {
      "ticket": "Ticket to test (e.g. AB-12345678901)",
      "run": "Test",
      "matched": "Matched — the rule will run on this ticket",
      "not_matched": "Not matched — the rule will skip this ticket",
      "reasons": "Per-condition results",
      "actions": "What the rule would do",
      "pass": "matched",
      "fail": "not matched",
      "would": "(dry-run — nothing was changed)",
      "skipped": "skipped: {{reason}}",
      "error": "failed",
      "cond_empty": "No conditions (always matches)"
    },
    "err_json_to_builder": "This JSON structure (nested and/or/not or special action types) cannot be converted to the rule builder yet — keep editing in JSON"
  },
  "tpl": {
    "col_name": "Template name",
    "col_langs": "Languages",
    "col_kind": "Kind",
    "test_send": "Send test email",
    "test_recipient": "Test recipient (email)",
    "test_lang": "Language",
    "test_sent": "Sent to {{email}} ({{lang}}) via the local provider — check the recipient's inbox",
    "system_no_delete": "System templates cannot be deleted (used by automated flows)",
    "kind_system": "System",
    "kind_canned": "Canned",
    "kind_signature": "Signature",
    "kind_auto_reply": "Auto reply",
    "name_placeholder": "Name",
    "subject_placeholder": "Subject",
    "body_placeholder": "Body HTML ({{a.b}} escaped, {{{raw}}} unescaped)"
  },
  "settings": {
    "tab": {
      "security": "Security (security)",
      "notification_defaults": "Notification defaults (notification_defaults)",
      "customization": "Customization (customization)",
      "feature_flags": "Feature flags (feature_flags)",
      "files": "Files (files)",
      "integrations": "Integrations (integrations)",
      "ai": "AI (ai)",
      "portal": "Portal (portal)",
      "mail": "Mail (mail)"
    },
    "hint": {
      "security": "Session security and IP allowlist enforcement",
      "notification_defaults": "Default channels per event per role (users can override per person)",
      "customization": "System title, logo, and page footer",
      "feature_flags": "Feature flag defaults (overview lives on the Feature flags page)",
      "files": "Attachment size limits",
      "integrations": "External integrations (secrets are set on dedicated pages)",
      "ai": "AI budget and per-feature switches",
      "portal": "Logged-out portal settings",
      "mail": "System-wide mail settings (e.g. eDiscovery approvers)"
    },
    "json_view": "JSON view",
    "json_value": "Value (JSON)",
    "err_json": "Invalid JSON",
    "dirty": "Unsaved changes",
    "notif": {
      "event": "Event"
    },
    "customization": {
      "title": "System title",
      "logo_url": "Logo URL",
      "footer_html": "Page footer (HTML)",
      "footer_hint": "Shown on every page — can be empty"
    },
    "security": {
      "reauth_max_age_sec": "Re-authentication max age (seconds)",
      "session_idle_min": "Session idle timeout (minutes)",
      "session_absolute_hours": "Session absolute lifetime (hours)",
      "ip_allowlist": "IP allowlist per role",
      "ip_placeholder": "10.0.0.0/8, 203.0.113.5 (comma-separated)",
      "ip_hint": "Empty = no IP restriction for that role"
    }
  },
  "mail_drafts": {
    "empty": "No email drafts",
    "no_subject": "(No subject)",
    "delete": "Delete draft",
    "saved_attachment": "Saved attachment"
  },
  "tasks": {
    "nav": "Internal tasks",
    "title": "Internal tasks",
    "my_work": "My work",
    "group_assigned": "Assigned to me",
    "group_watching": "Watched by me",
    "group_created": "Created by me",
    "overdue": "overdue",
    "overdue_count": "{{count}} overdue tasks",
    "projects": "Projects",
    "no_projects": "No projects yet",
    "new_project": "New project",
    "create_project": "Create project",
    "project_name": "Project name",
    "project_description": "Description",
    "project_icon": "Icon (emoji)",
    "project_color": "Color",
    "visibility": "Visibility",
    "visibility_company": "Whole company",
    "visibility_private": "Members only",
    "role_manager": "Project manager",
    "role_member": "Member",
    "role_viewer": "View only",
    "counts_open": "{{count}} open",
    "counts_done": "{{count}} done",
    "counts_overdue": "{{count}} overdue",
    "back": "Back",
    "view_toggle": "View",
    "board": "Board",
    "list": "List",
    "done_window": "Completed tasks window",
    "done_days_option": "last {{count}} days",
    "quick_add": "Type a task title and press Enter",
    "all": "All",
    "all_labels": "All labels",
    "filter_q": "Search tasks",
    "filter_status": "Filter by status",
    "filter_assignee": "Filter by assignee",
    "filter_label": "Filter by label",
    "no_assignee_filter": "All assignees",
    "move_conflict": "Could not move the card — the board was changed by someone else, reloading",
    "edit_conflict": "Could not save — the task was changed by someone else, reloading",
    "detail_title": "Task detail",
    "field_status": "Status",
    "field_title": "Title",
    "field_description": "Description",
    "field_assignee": "Assignee",
    "field_priority": "Priority",
    "field_due": "Due",
    "field_labels": "Labels",
    "no_assignee": "Unassigned",
    "no_due": "No due date",
    "priority_low": "Low",
    "priority_normal": "Normal",
    "priority_high": "High",
    "priority_urgent": "Urgent",
    "subtasks": "Subtasks",
    "subtask_add": "Add subtask…",
    "subtask_done_toggle": "Mark done",
    "subtask_reopen": "Reopen",
    "checklist": "Checklist",
    "checklist_add": "Add checklist item…",
    "checklist_delete": "Delete item",
    "comments": "Comments",
    "comment_placeholder": "Write a comment… (type @name to mention)",
    "comment_post": "Post comment",
    "watchers": "Watchers",
    "watch_me": "Watch this task",
    "add_watcher": "Add watcher",
    "remove_watcher": "Remove watcher",
    "history": "History",
    "delete_task": "Delete task",
    "delete_confirm": "Click again to confirm deletion",
    "created_by": "Created by",
    "event_task_created": "created the task",
    "event_task_edited": "edited the task",
    "event_task_status_changed": "changed status",
    "event_task_assigned": "changed assignee",
    "event_task_due_changed": "changed due date",
    "event_task_priority_changed": "changed priority",
    "event_task_moved": "moved the card",
    "event_task_comment_added": "commented",
    "event_task_deleted": "deleted the task",
    "event_checklist_added": "added a checklist item",
    "event_checklist_done": "checked a checklist item",
    "event_label_changed": "changed labels",
    "event_watcher_added": "added a watcher",
    "attach_title": "Attachments",
    "attach_upload": "Upload file",
    "attach_uploading": "Uploading… {{pct}}%",
    "attach_delete": "Delete attachment",
    "attach_empty": "No attachments yet",
    "tickets_title": "Linked customer tickets",
    "tickets_empty": "No tickets linked to this task",
    "tickets_open": "Open ticket",
    "ticket_create": "Create ticket from this task",
    "ticket_service": "Service code",
    "ticket_service_placeholder": "Select a service",
    "ticket_team": "Team (optional)",
    "ticket_team_none": "No team",
    "ticket_subject": "Ticket subject",
    "ticket_body_preview": "Preview of the body to be sent",
    "ticket_body_note": "The system will include the task description above with a link back to this task automatically.",
    "ticket_create_submit": "Create ticket",
    "ticket_already_linked": "This ticket is already linked",
    "report_tab": "Report",
    "report_workload": "Workload per person",
    "report_name": "Name",
    "report_holding": "Open",
    "report_overdue_col": "Overdue",
    "report_overdue_title": "Overdue tasks",
    "report_overdue_empty": "No overdue tasks",
    "report_done_per_week": "Tasks completed per week (last 8 weeks)",
    "report_not_found": "Report not found — this project is private and you are not a member"
  }
}
